import React from "react";
import { LinearProgress, styled } from "@mui/material";

const StyledLinearProgress = styled(LinearProgress)<{
  maxWidth: string;
  thickness: number;
  fillColor?: string;
  borderRadius?: string;
  bgColor?: string;
}>`
  width: 100%;
  height: ${({ thickness }) => thickness}px;
  background-color: ${({ bgColor }) => bgColor};
  border-radius: ${({ borderRadius }) => borderRadius ?? "0px"};
  max-width: ${({ maxWidth }) => maxWidth};

  .MuiLinearProgress-bar {
    background-color: ${({ fillColor }) => fillColor};
    border-radius: ${({ borderRadius }) => borderRadius ?? "0px"};
    transition: transform 0.3s ease-in-out;
  }
`;

interface Props {
  progress: number;
  maxWidth?: string;
  color?: string;
  thickness?: number;
  borderRadius?: string;
  bgColor?: string;
}

export const LinearProgressBar = ({
  progress,
  maxWidth = "100%",
  color,
  borderRadius,
  thickness = 4,
  bgColor,
}: Props) => (
  <StyledLinearProgress
    variant="determinate"
    value={progress}
    maxWidth={maxWidth}
    thickness={thickness}
    fillColor={color}
    bgColor={bgColor}
    borderRadius={borderRadius}
  />
);
